import { useLazyQuery } from '@moonpig/web-core-graphql'
import { logger } from '@moonpig/web-core-monitoring'
import { GetMultiBuyListQuery } from './__generated__/getMultiBuyListGQL'
import { GetMultiBuyListGQL } from './getMultiBuyListGQL'

export const useFetchMultiBuyList = () => {
  const [fetchMultiBuyList, { data: multiBuyListData, error }] =
    useLazyQuery<GetMultiBuyListQuery>(GetMultiBuyListGQL, {
      ssr: false,
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    })

  if (error) {
    logger.fixToday('Failed to fetch multi buy list', {
      message: error.message,
    })
  }

  const multiBuyListItems = multiBuyListData?.me.multiBuyList?.items ?? []
  const multiBuyListItemCount =
    multiBuyListData?.me.multiBuyList?.itemCount ?? 0

  return {
    fetchMultiBuyList,
    multiBuyListItems,
    multiBuyListItemCount,
    hasError: Boolean(error),
  }
}
